import { useTranslation } from "react-i18next";
import { useLangFont } from "../../../hooks/useLangFont";

export default function WhyChooseUs() {
  const { t } = useTranslation();
  const { heading, body } = useLangFont();

  const reasons = [
    {
      icon: "ri-flashlight-line",
      label: t("why_speed_label"),
      title: t("why_speed_title"),
      desc: t("why_speed_desc"),
      compare: [
        { label: t("why_speed_other_label"), value: t("why_speed_other_val"), highlight: false },
        { label: t("why_speed_us_label"), value: t("why_speed_us_val"), highlight: true },
      ],
    },
    {
      icon: "ri-shield-check-line",
      label: t("why_quality_label"),
      title: t("why_quality_title"),
      desc: t("why_quality_desc"),
      compare: [
        { label: t("why_quality_target_label"), value: t("why_quality_target_val"), highlight: false },
        { label: t("why_quality_period_label"), value: t("why_quality_period_val"), highlight: true },
      ],
    },
  ];

  return (
    <section id="why" className="py-28 bg-[#F8F7F4] w-full">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span
            className="inline-block bg-[#C9A84C] text-[#1A2332] text-xs font-bold tracking-[0.3em] uppercase px-4 py-2 rounded-full mb-4"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Why Choose Us
          </span>
          <h2
            className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-4 tracking-tight"
            style={{ fontFamily: heading }}
          >
            {t("why_title")}
          </h2>
          <p
            className="text-gray-500 text-sm tracking-wide"
            style={{ fontFamily: body }}
          >
            {t("why_subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {reasons.map((r) => (
            <div
              key={r.label}
              className="bg-white rounded-2xl p-8 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#1A2332]">
                  <i className={`${r.icon} text-[#C9A84C] text-2xl`} />
                </div>
                <span
                  className="text-[#C9A84C] text-xs font-bold tracking-[0.25em] uppercase"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {r.label}
                </span>
              </div>

              <h3
                className="text-3xl font-bold text-[#1A2332] mb-4 leading-snug whitespace-pre-line tracking-tight"
                style={{ fontFamily: heading }}
              >
                {r.title}
              </h3>
              <p
                className="text-gray-500 text-sm leading-relaxed mb-7"
                style={{ fontFamily: body }}
              >
                {r.desc}
              </p>

              <div className="flex gap-4">
                {r.compare.map((c) => (
                  <div
                    key={c.label}
                    className={`flex-1 rounded-xl px-4 py-4 text-center ${
                      c.highlight ? "bg-[#1A2332] text-white" : "bg-gray-100 text-gray-400"
                    }`}
                  >
                    <p
                      className="text-[10px] tracking-widest mb-1 opacity-70"
                      style={{ fontFamily: body }}
                    >
                      {c.label}
                    </p>
                    <p
                      className={`text-base font-bold ${c.highlight ? "text-[#C9A84C]" : ""}`}
                      style={{ fontFamily: "'Montserrat', sans-serif" }}
                    >
                      {c.value}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
